import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../apollo-client';

import {QuotasNoTeamsBanner} from './quotas-no-teams-banner';

export function mountQuotasNoTeamsBanner() {
    const quotasNoTeamsBannerContainer = document.querySelector(
        '#quotas-no-teams-banner-react-mount'
    );
    if (quotasNoTeamsBannerContainer) {
        ReactDOM.render(
            <ApolloProvider client={nutApolloClient}>
                <ReactHooksApolloProvider client={nutApolloClient}>
                    <QuotasNoTeamsBanner />
                </ReactHooksApolloProvider>
            </ApolloProvider>,
            quotasNoTeamsBannerContainer
        );
    }
}
